import { Component } from 'react';
import cx from 'classnames';
import { Router } from '../../configs/routes';
import Field from '../ui/field';
import Button from '../ui/button';
import Modal from '../modal';
import { DOWNLOAD_OPTIONS_FIELD } from '../../constants/userFields';
import { trackAction } from '../../utils/trackActions';
import styles from '../../styles/compareFunds.scss';

import { Api } from '../../api';

const api = new Api();

interface State {
  field: any;
  isDownloading: boolean;
  errorMessage: string;
}

class DownloadProofHandler extends Component<any, any> {
  public state: State = {
    field: { ...DOWNLOAD_OPTIONS_FIELD },
    isDownloading: false,
    errorMessage: '',
  };

  public componentDidMount() {
    this.setState({
      field: this.buildYearOptions(),
    });
  }

  private buildYearOptions = () => {
    const { field } = this.state;
    const { elssInvestmentYears } = this.props;
    const options = [];
    const date = new Date();
    const curYear = +date
      .getFullYear()
      .toString()
      .slice(2);
    const month = date.getMonth();
    elssInvestmentYears.map((year: string) => {
      const sYear = +year.toString().slice(2, 4);
      const eYear = +year.toString().slice(4);
      const yearLabel =
        `20${sYear}-${eYear}` +
        (curYear === sYear && month > 3 ? ' (current financial year)' : '');
      const option = {
        label: yearLabel,
        value: `FY${sYear}${eYear}`,
      };
      options.push(option);
    });

    field.options = options;

    return field;
  };

  private onChange = (e: any) => {
    const { value } = e.target;
    this.setState({
      errorMessage: '',
      field: { ...this.state.field, value },
    });
  };

  private downloadInvProof = () => {
    this.setState({ isDownloading: true });
    trackAction('download-elss-proof', 'elss-proof');
    api.downloadInvestmentProof(this.state.field.value).then(response => {
      let errorMessage = '';
      if (response && response.status === 404) {
        errorMessage = 'Unable to find investment entry for the selected year.';
      } else if (response && response.status === 401) {
        const path = `/save/login?refer=${encodeURIComponent(
          '/save/dashboard/portfolio'
        )}`;
        Router.pushRoute(path, path);
      } else {
        trackAction('download-elss-proof-success', 'elss-proof');
      }
      this.setState({ isDownloading: false, errorMessage });
    });
  };

  public render() {
    const { field, isDownloading, errorMessage } = this.state;
    return (
      <Modal
        onDismiss={this.props.onDismiss}
        title="Download Investment Proof"
        showFooter={false}
        headerPad={16}
      >
        <div className="row download-options ml0 mr0">
          <Field
            id={field.name}
            className={cx(
              'columns large-10 download mb15',
              styles['filter-select']
            )}
            disabled={false}
            {...field}
            onChange={this.onChange}
          />
          {errorMessage ? (
            <div className="large-12 columns mb20">
              <span className="font--red">{errorMessage}</span>
            </div>
          ) : null}
          <div className="large-12 columns mb20 font--fadedgrey text--medium">
            <sup>*</sup>Statements are available only for years in which
            tax-saving investments were made on ClearTax
          </div>
        </div>
        <div className="large-4 columns mb15">
          <Button
            label="Download"
            type="primary"
            disabled={isDownloading}
            loadingLabel={'Downloading...'}
            className="s-btn s-btn--blue full-width"
            onClick={this.downloadInvProof}
          />
        </div>
      </Modal>
    );
  }
}

export default DownloadProofHandler;



// WEBPACK FOOTER //
// ./components/dashboard/downloadProofHandler.tsx